import React, {useContext} from 'react';
import { UserContext } from '../partials/Context';

function AuthenticatedUserNavbar(props) {
        const user = useContext(UserContext);
        const {is_authenticated} = user || '';
        const {links, messages} = props
        const {links: authenticated_links} = links || [];
        let list = [];

        if (is_authenticated && authenticated_links) {
            authenticated_links.map((item, index) =>{
                item = authenticated_links[index];
                const {href, text} = item || '';
                if(text === 'Wiadomości') {
                    list.push(
                        <li key={index}><a href={href}>{text}<span className="badge badge-success circle" >{messages}</span></a></li>
                    )
                } else {
                    list.push(
                        <li key={index}><a href={href}>{text}</a></li>
                    )}
                return list
            })
        }

        if(is_authenticated === true) {
            return(
                <nav id="authenticated-user-navbar" className="navbar animated fadeInDown hidden-xs" role="navigation">
                    <div className="container">
                        <div>
                            <ul className="nav nav-pills">
                                {list}
                            </ul>
                        </div>
                    </div>
                </nav>
            )
        }
}

export default AuthenticatedUserNavbar;